<template>
  <div class="historico-container">
    <h4 class="historico-title mb-3">Histórico</h4>

    <!-- Abas -->
    <div class="tabs-header mb-3">
      <button
        class="tab-item"
        :class="{ active: activeTab === 'statements' }"
        @click="activeTab = 'statements'"
      >
        Demonstrativos
      </button>
      <button
        class="tab-item"
        :class="{ active: activeTab === 'invoices' }"
        @click="activeTab = 'invoices'"
      >
        Notas Enviadas
      </button>
    </div>

    <!-- Renderização Condicional dos Subcomponentes das Abas -->
    <HistoryStatementsTab
      v-if="activeTab === 'statements'"
      :items="statementItems"
      @download="$emit('download-statement', $event)"
    />

    <HistoryInvoicesTab
      v-else
      :items="invoiceItems"
      @download="$emit('download-invoice', $event)"
      @delete="$emit('delete-invoice', $event)"
    />

    <!-- Paginação -->
    <div class="pagination-wrapper mt-3 d-flex justify-content-center">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        size="sm"
        class="custom-pagination"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
// Ajustado: Removida a subpasta ./history/ para encontrar os arquivos na mesma pasta
import HistoryStatementsTab from "./history/HistoryStatementsTab.vue";
import HistoryInvoicesTab from "./history/HistoryInvoicesTab.vue";

export default {
  name: "ProductionHistory",
  components: {
    HistoryStatementsTab,
    HistoryInvoicesTab,
  },
  data() {
    return {
      activeTab: "statements",
      currentPage: 1,
      perPage: 6,
      totalRows: 18,

      // Mocks de Dados
      statementItems: [
        { id: 1, competence: "04/2026", description: "Produção Médica PF - Recebimentos", fileFormat: "pdf" },
        { id: 2, competence: "04/2026", description: "Produção Médica PF - Recebimentos", fileFormat: "csv" },
        { id: 3, competence: "04/2026", description: "Produção Médica PF - Recebimentos", fileFormat: "xml" },
        { id: 4, competence: "03/2026", description: "Reuniões - Recebimentos", fileFormat: "xml" },
        { id: 5, competence: "03/2026", description: "Reuniões - Recebimentos", fileFormat: "pdf" },
        { id: 6, competence: "02/2026", description: "Produção Médica PF - Recebimentos", fileFormat: "pdf" },
      ],

      invoiceItems: [
        { id: 1, competence: "04/2026", invoiceNumber: "12345678910111213", integrationDate: "07/04/2025", canDelete: true },
        { id: 2, competence: "04/2026", invoiceNumber: "12345678910111213", integrationDate: "07/04/2025", canDelete: false },
        { id: 3, competence: "04/2026", invoiceNumber: "12345678910111213", integrationDate: "07/04/2025", canDelete: false },
        { id: 4, competence: "03/2026", invoiceNumber: "12345678910111213", integrationDate: "07/03/2025", canDelete: false },
        { id: 5, competence: "03/2026", invoiceNumber: "12345678910111213", integrationDate: "07/03/2025", canDelete: false },
        { id: 6, competence: "02/2026", invoiceNumber: "12345678910111213", integrationDate: "07/02/2025", canDelete: false },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.historico-container {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 16px;

  .historico-title {
    font-weight: 700;
    font-size: 16px;
    color: #212529;
  }

  .tabs-header {
    display: flex;
    gap: 1px;
    border-bottom: 2px solid #DFDFDF;

    .tab-item {
      border: none;
      background: transparent;
      padding: 14px 16px;
      font-weight: 700;
      font-size: 14px;
      color: #212529;
      cursor: pointer;

      &.active {
        border-bottom: 2px solid #007A4A;
        color: #007A4A;
      }
    }
  }

  /* Estilização corrigida para o contêiner da paginação */
  .pagination-wrapper {
    ::v-deep .pagination {
      margin-top: 16px;
      margin-bottom: 0;
      gap: 4px; /* Espaçamento entre os botões */

      .page-item {
        .page-link {
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;

          /* Dimensões exatas do Figma */
          width: 31px !important;
          height: 29px !important;
          min-width: 31px !important;

          background: #FFFFFF;
          border: 0.5px solid #DEE2E6;
          border-radius: 4px;

          font-size: 14px;
          color: #212529;

          &:focus {
            box-shadow: none;
          }
        }

        /* Estado Ativo (Página selecionada) */
        &.active .page-link {
          background-color: #007A4A !important;
          border-color: #007A4A !important;
          color: #FFFFFF !important;
        }

        /* Estado Desabilitado */
        &.disabled .page-link {
          background-color: #F8F9FA !important;
          border-color: #DEE2E6 !important;
          color: #6C757D !important;
          opacity: 0.6;
        }
      }
    }
  }
}
</style>